export const SYSTEM_CONFIG = 'System Configuration';
export const NOTIFICATION_CONFIG = 'Notification Configuration';
export const USER_ROLE = 'User Role';

export const SET_SYSTEM_CONFIG_USECASES = 'SET_SYSTEM_CONFIG_USECASES';
